<template>
  <div class="sort-selector">
    <div v-if="sortby!='no'" class="sortby d-none d-md-inline-block" style="padding:0">
      <span class="label secondary_title" for="SortBy">{{$t('venue.productList.sort_buy')}}</span>
    </div>
    <el-select class="select"  v-model="sortvalue" @change="sort(sortvalue)" placeholder="请选择" @visible-change="visibleChange">
      <el-option :label="$t('venue.productList.featured')" value="manual"></el-option>
      <el-option :label="$t('venue.productList.best_selling')" value="best-selling"></el-option>
      <el-option :label="$t('venue.productList.alp_A_Z')" value="title-ascending"></el-option>
      <el-option :label="$t('venue.productList.alp_Z_A')" value="title-descending"></el-option>
      <el-option :label="$t('venue.productList.low_to_high')" value="price-ascending"></el-option>
      <el-option :label="$t('venue.productList.high_to_low')" value="price-descending"></el-option>
      <el-option :label="$t('venue.productList.date_new_to_old')" value="created-descending"></el-option>
      <el-option :label="$t('venue.productList.date_old_to_new')" value="created-ascending"></el-option>
      <el-option v-if="show_star" :label="$t('venue.productList.review_high_to_low')" value="review-descending"></el-option>
      <el-option v-if="show_star" :label="$t('venue.productList.rating_high_to_low')" value="rating-descending"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: ["sortvalue", "sortby",'show_star'],
  methods: {
    visibleChange(e){
      let input_el=this.$('.select>.el-input>.el-input__inner');
      if(e){
        input_el.addClass('main_button_boder')
      }else{
        input_el.removeClass('main_button_boder');
      }
    },
    sort(val) {
      window.open(this.replaceSearch("sort", val), "_self");
    }
  }
};
</script>

<style lang="scss" scoped>
.sort-selector {
  label {
    vertical-align: sub;
  }
  .select {
    width: 70%;
    & ::v-deep .el-input .el-input__inner:focus{
      border-color: #C0C4CC;
    }
  }
} 
@media screen and (max-width: 768px) {
  .sort-selector {
    .select {
      width: 100%;
    }
  }
}
</style>
<style lang="scss">
.el-select-dropdown{
   .el-select-dropdown__item.hover{
     background-color: #f9f9f9 !important;
   }
}
</style>